import React, { useContext } from 'react';
// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';
import { AuthContext } from 'context/authContext';
import Heading from 'components/atoms/Heading';
import Logo from 'components/atoms/Logo';
import Button from 'components/atoms/Button';
import LoginTemplate from '../../templates/LoginTemplate';
import Field from '../../molecules/Field';
import Form, { useForm } from '../../molecules/Form';
import { SubTitle, LoginHead, FormHolder, StyledForm } from './Login.styles';


function Login() {
  const [form] = useForm();
  const { onLogin, loading_user} = useContext(AuthContext);
  return (
    <LoginTemplate>
      <LoginHead>
        <Logo />
      </LoginHead>
      <FormHolder>
        <Heading level={1}>Sign in</Heading>
        <SubTitle>
          Hello there! Sign in and start managing <br /> students.
        </SubTitle>
        <StyledForm form={form} onSubmit={onLogin}>
          <Form.Item
            type="text"
            label="Email / Username"
            name="email"
            placeholder="Your Email or Username"
            prefix={<i className="material-icons-outlined">email</i>}
            rules={[{ required: true }, { pattern: /^.{0,256}$/, message: 'Maximum Character Length is 256' }]}>
            <Field />
          </Form.Item>
          <Form.Item
            type="password"
            label="Password"
            name="password"
            placeholder="Your Password"
            prefix={<i className="material-icons-outlined">lock</i>}
            rules={[
              {
                required: true,
              },
              { pattern: /^.{8,64}$/, message: 'Minimum Character Length is 8 and Maximum Character Length is 64' },
            ]}>
            <Field />
          </Form.Item>
          <Button loading={loading_user} type="primary" htmlType="submit" width={150} css="margin: 0 auto;">
            Sign in
          </Button>
        </StyledForm>
      </FormHolder>
    </LoginTemplate>
  );
}

export default Login;
